import { Box, Link, Typography } from "@mui/material";
import { CTextFieldPassword } from "@/components/TextField/CTextFieldPassword";
import { Button, ButtonVariantOption } from "@/components/Button";
import { SizingWrapperStyle } from "@/components/Wrapper";
import { Divider } from "@/components/Divider";
import { PagePaper, SectionPaper } from "@/components/Paper";
import { PageTitle, SectionTitle } from "@/components/Title";
import { Label } from "@/components/Label";
import { KeyboardArrowLeft } from "@mui/icons-material";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import { ConsumeCredit } from "./components/ConsumeCredit";
import { useFeatureFlags } from "@/configs/featureFlag";
import { UserConfig } from "@/features/accountSettings/components/UserConfig";

import { type UseFormReturn } from "react-hook-form";
import { type ChangePasswordFormData } from "./types/schemas";

interface IAccountSettingsPresenterProps {
  form: UseFormReturn<ChangePasswordFormData>;
  handleSubmit: (data: ChangePasswordFormData) => Promise<void>;
}
export const AccountSettingsPresenter: React.FC<
  IAccountSettingsPresenterProps
> = ({ form, handleSubmit }) => {
  const { mypageTop } = useFeatureFlags();
  return (
    <PagePaper>
      <form>
        {/* ページタイトル */}
        <Box sx={{ display: "flex", mb: 3 }}>
          <ContactPageIcon sx={{ mr: 1 }} fontSize="large" />
          <PageTitle>アカウント情報</PageTitle>
        </Box>
        <Box sx={{ display: "flex", mb: 3 }}>
          <ConsumeCredit></ConsumeCredit>
        </Box>
        <SectionPaper>
          <SectionTitle>パスワードの変更</SectionTitle>
          <Divider />
          {/* パスワード変更 */}
          <Box sx={{ m: 2 }}>
            <Box sx={{ mb: 2 }}>
              <CTextFieldPassword
                control={form.control}
                name="currentPassword"
                label="現在のパスワード"
                autoComplete="current-password"
                size={SizingWrapperStyle.LARGE}
                required={false} // 必須が明確なので必須マークは不要
              />
            </Box>

            <Box sx={{ mb: 2 }}>
              <CTextFieldPassword
                control={form.control}
                name="newPassword"
                label="新しいパスワード"
                autoComplete="new-password"
                size={SizingWrapperStyle.LARGE}
                required={false} // 必須が明確なので必須マークは不要
              />
            </Box>

            <CTextFieldPassword
              control={form.control}
              name="newPasswordConfirmation"
              label="新しいパスワード（確認）"
              autoComplete="new-password"
              size={SizingWrapperStyle.LARGE}
              required={false} // 必須が明確なので必須マークは不要
            />
          </Box>

          <Divider />

          {/* 保存ボタン */}
          <Box
            sx={{
              mr: 2,
              my: 3,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              label="保存"
              onClick={() => {
                void form.handleSubmit(handleSubmit)();
              }}
              variant={ButtonVariantOption.Contained}
              size={SizingWrapperStyle.SMALL}
            />
          </Box>
        </SectionPaper>

        <Box sx={{ display: "flex", my: 3 }}>
          <UserConfig />
        </Box>

        {/* 戻る */}
        <Box sx={{ mt: 2 }}>
          <Link
            href={mypageTop ? "/mypage" : "/feed"}
            sx={{ display: "inline-block" }}
          >
            <Box sx={{ display: "flex" }}>
              <KeyboardArrowLeft />
              <Typography>
                {mypageTop ? "マイページに戻る" : "不動産の権利異動検索に戻る"}
              </Typography>
            </Box>
          </Link>
        </Box>
      </form>
    </PagePaper>
  );
};
